/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Requester_CustomerInputs */

const en_claim_requester_customer = /** @type {(inputs: Claim_Requester_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The customer who opened it`)
};

/**
* | output |
* | --- |
* | "The customer who opened it" |
*
* @param {Claim_Requester_CustomerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_requester_customer = /** @type {((inputs?: Claim_Requester_CustomerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Requester_CustomerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_requester_customer(inputs)
});